import { render, staticRenderFns } from "./product_inventory.vue?vue&type=template&id=6362e9bf&scoped=true"
import script from "./product_inventory.vue?vue&type=script&lang=js"
export * from "./product_inventory.vue?vue&type=script&lang=js"
import style0 from "./product_inventory.vue?vue&type=style&index=0&id=6362e9bf&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6362e9bf",
  null
  
)

export default component.exports